/**
 * @param {string} date ISO 8601 format (e.g., 2023-02-01T00:00:00.000Z)
 * @returns {string} Formatted date (e.g., Feb 1, 2023)
 */
export default function formatDate(date, useUTC = true) {
  return new Date(Date.parse(date)).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...(useUTC ? { timeZone: 'UTC' } : {}),
  });
}

/**
 * @param {string|number} date ISO 8601 format or unix timestamp
 * @returns {string} Formatted date (e.g., 02/01/2023)
 */
export function formatDateMMDDYYYY(date, useUTC = true) {
  if (!date) return '';
  const dateObj = typeof date === 'number' ? new Date(date * 1000) : new Date(Date.parse(date));
  if (Number.isNaN(dateObj.getTime())) return '';
  return dateObj.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...(useUTC ? { timeZone: 'UTC' } : {}),
  });
}
